<template>
    <el-dialog :title="title" :visible.sync="dialogTableVisible" @close="closeDialog" width="80%" top="5vh">
        <div class="userInfo-group">
            <span>客户信息</span>
            <el-row>
                <el-col :span="6" :offset="2" class="order-item">
                    用户名：{{accountInfo.username}}
                </el-col>
                <el-col :span="12" :offset="4" class="order-item">
                    手机号码：{{accountInfo.mobile}}
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" :offset="2" class="order-item">
                    真实姓名：{{accountInfo.real_name}}
                </el-col>
                <el-col :span="12" :offset="4" class="order-item">
                    身份：{{accountInfo.identity_name}}
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" :offset="2" class="order-item">
                    设为管理员：{{accountInfo.is_admin ? '是' : '否'}}
                </el-col>
                <el-col :span="12" :offset="4" class="order-item">
                    公有状态：{{accountInfo.is_common ? '是' : '否'}}
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" :offset="2" class="order-item">
                    启用产品：
                    <span v-for="(item, index) in products" v-show="!close_product_ids.includes(item.id)" :key="index">
                        {{item.name}}&nbsp;&nbsp;&nbsp;
                    </span>
                </el-col>
            </el-row>
        </div>
        <div class="userInfo-group">
            <span>登录日志</span>
            <el-table :data="list" height="500" v-loading="loading">
                <el-table-column property="device" label="设备信息" show-overflow-tooltip></el-table-column>
                <el-table-column property="loginsource" label="登录端口"></el-table-column>
                <el-table-column property="logintime" label="登录时间"></el-table-column>
                <el-table-column property="gateip" label="登录IP"></el-table-column>
                <el-table-column property="status_str" label="状态"></el-table-column>
            </el-table>
            <el-row style="text-align: center;">
                <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
            </el-row>
        </div>
        
    </el-dialog>
</template>
<script>
    import CustomerAccountsService from "~/services/CustomerAccounts";
    import MyPagination from "~/widgets/MyPagination.vue";
    export default {
        props:{
            params:{
                type: Object,
                required: true,
            },
            title:{
                type: String,
                required: false,
                default: '详情'
            },
        },
        components: {
            MyPagination
        },
        data(){
            return {
                list:[],
                loading: false,
                dialogTableVisible: true,
                linkPage: null,
                searcheModel: {},
                accountInfo: {},
                products: [
                    {name: '二一校网通', id: 2},
                    // {name: '二一组卷', id: 1},
                    {name: '校本资源库', id: 5},
                ],
                close_product_ids: []
            }
        },
        created() {
            this.getAccountInfo();
            this.resetForm();
        },
        methods: {
            //重置按钮
            resetForm() {
                this.searcheModel = {
                    uid: '',
                };
                this.list = [];
                this.submitSearch();
            },

            // 筛选查询
            submitSearch($data = null) {
                if($data && typeof $data.order !== undefined){
                    this.searcheModel.sort_name = $data['prop'];
                    this.searcheModel.sort_by = $data['order'];
                }
                let params = _.clone(this.searcheModel);
                params['page'] = 1;
                _.each(params, (val, key) => {
                    // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                    if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                        delete params[key];
                    }
                })
                this.getList(params);
            },

            //获取列表
            getList() {
                // loading 动画
                this.loading = true;
                CustomerAccountsService.getLoginLog(this.params).then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                    }
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    console.error(err);
                    this.loading = false;
                });
            },

            //获取列表
            getAccountInfo() {
                // loading 动画
                CustomerAccountsService.getInfo(this.params).then((res) => {
                    if (res.code == 0) {
                        this.accountInfo = res.data;
                        this.close_product_ids = this.accountInfo.closeProducts.map(item => parseInt(item.product_id));
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
            },

            handleSizeChange(newSize) {
                // 处理每页条目数变化事件
                let params = this.params;
                params['perPage'] = newSize;
                this.getList(params);
            },

            handleCurrentChange(newPage) {
                let params = this.params;
                // 处理当前页码变化事件
                params['page'] = newPage;
                this.getList(params);
            },
            
            closeDialog(){
                this.dialogTableVisible = false;
                this.$emit("close", []);
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/public_acc/viewDialog.vue